<template>
  <div class="farewell">
    <h1>Farewell Bernie!</h1>
    <ul class="beatbox">
      <li class="beatbox__item" v-for="item in items">

        <soundButton v-bind:item="item"></soundButton>

      </li>
    </ul>
  </div>
</template>

<script>

import SoundButton from './SoundButton.vue'

export default {
  name: 'FarewellBerneie',
  components: {
    SoundButton
  },
  data () {
    return {
      items: require('../assets/data/items').items
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
h1 {
  display: inline-block;
  padding: 0.25em 0.5em;
}

@media screen and (min-width: 1200px) {
  h1 {
    font-size: 3em;
    margin-bottom: 0.25em;
  }
}

.farewell {

}
.beatbox {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  align-items: center;
  align-content: center;
  list-style-type: none;
  padding: 0;
}
li {
  display: flex;
  flex: 0 1 33%;
  width: 33%;
}

@media screen and (min-width: 450px) {
  li {
    flex-basis: auto;
    width: auto;
  }
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/FarewellBernie.vue